export default class ChapterIntroductionEvent {
    constructor(type) {
        this.type = type;
    }
}

ChapterIntroductionEvent.FINISH = "ChapterIntroductionEvent.FINISH";